import armLeft from '~/assets/icons/arm_left.svg';
import armRight from '~/assets/icons/arm_right.svg';
import backBody from '~/assets/icons/back_body.svg';
import head from '~/assets/icons/head.svg';
import legLeft from '~/assets/icons/leg_left.svg';
import legRight from '~/assets/icons/leg_right.svg';
import neck from '~/assets/icons/neck_2.svg';
import deleteIcon from '~/assets/icons/tattoo_delete.svg';
import torso from '~/assets/icons/torso.svg';
import torso2 from '~/assets/icons/torso_2.svg';
import { TattooCategory } from '~/shared';

export const CategoryNames = {
	[TattooCategory.HEAD]: 'Голова',
	[TattooCategory.NECK]: 'Шея',
	[TattooCategory.ARM_RIGHT]: 'Правая рука',
	[TattooCategory.ARM_LEFT]: 'Левая рука',
	[TattooCategory.BREAST]: 'Грудь',
	[TattooCategory.BELLY]: 'Живот',
	[TattooCategory.BACK_BODY]: 'Спина',
	[TattooCategory.LEG_RIGHT]: 'Правая нога',
	[TattooCategory.LEG_LEFT]: 'Левая нога',
};

export const CategoryImages = {
	[TattooCategory.HEAD]: head,
	[TattooCategory.NECK]: neck,
	[TattooCategory.ARM_RIGHT]: armRight,
	[TattooCategory.ARM_LEFT]: armLeft,
	[TattooCategory.BREAST]: torso,
	[TattooCategory.BELLY]: torso2,
	[TattooCategory.BACK_BODY]: backBody,
	[TattooCategory.LEG_RIGHT]: legRight,
	[TattooCategory.LEG_LEFT]: legLeft,
};

export interface ICategory {
	id: number;
	type: TattooCategory | 'delete';
	name: string;
	image: string;
}

export const categories: ICategory[] = [
	{
		id: -1,
		type: 'delete',
		name: 'Удаление тату',
		image: deleteIcon,
	},
	{
		id: 0,
		type: TattooCategory.HEAD,
		name: CategoryNames[TattooCategory.HEAD],
		image: CategoryImages[TattooCategory.HEAD],
	},
	{
		id: 1,
		type: TattooCategory.NECK,
		name: CategoryNames[TattooCategory.NECK],
		image: CategoryImages[TattooCategory.NECK],
	},
	{
		id: 2,
		type: TattooCategory.ARM_RIGHT,
		name: CategoryNames[TattooCategory.ARM_RIGHT],
		image: CategoryImages[TattooCategory.ARM_RIGHT],
	},
	{
		id: 3,
		type: TattooCategory.ARM_LEFT,
		name: CategoryNames[TattooCategory.ARM_LEFT],
		image: CategoryImages[TattooCategory.ARM_LEFT],
	},
	{
		id: 4,
		type: TattooCategory.BREAST,
		name: CategoryNames[TattooCategory.BREAST],
		image: CategoryImages[TattooCategory.BREAST],
	},
	{
		id: 5,
		type: TattooCategory.BELLY,
		name: CategoryNames[TattooCategory.BELLY],
		image: CategoryImages[TattooCategory.BELLY],
	},
	{
		id: 6,
		type: TattooCategory.BACK_BODY,
		name: CategoryNames[TattooCategory.BACK_BODY],
		image: CategoryImages[TattooCategory.BACK_BODY],
	},
	{
		id: 7,
		type: TattooCategory.LEG_RIGHT,
		name: CategoryNames[TattooCategory.LEG_RIGHT],
		image: CategoryImages[TattooCategory.LEG_RIGHT],
	},
	{
		id: 8,
		type: TattooCategory.LEG_LEFT,
		name: CategoryNames[TattooCategory.LEG_LEFT],
		image: CategoryImages[TattooCategory.LEG_LEFT],
	},
];

export const getCategoryByType = (type: TattooCategory | null | 'delete') => {
	return categories.find((category) => category.type === type);
};
